module.exports = __webpack_public_path__ + "static/OneDotExt-BoldItalic.6df013c3.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt-BoldItalic.woff2
// module id = 752
// module chunks = 114276838955818